import * as actions from '../actionTypes';
import { GET_ASSIGNMENTS, ADD_ASSIGNMENT, UPDATE_ASSIGNMENT, DELETE_ASSIGNMENT } from '../api';
import client from '../apolloClient';
import { setGrades } from './gradeActions';

export const deleteAssignment = (assignment_id) => async (dispatch, getState) => {
    try {
        await client.mutate({
            mutation: DELETE_ASSIGNMENT,
            variables: { input: assignment_id },
        });
        const action = { type: actions.DELETE_ASSIGNMENT, payload: assignment_id };
        dispatch(action);
         // Get the current state
         const state = getState();

         // Find the deleted assignment
         const assignment = state.assignments.find(en => en._id === assignment_id);
 
         if (assignment) {
            
             // Filter grades related to the student and assignments of the enrollment
             const grades = state.grades.filter(gr => gr.assignment._id==assignment_id);
 
             // Dispatch actions to remove the grades from the state
             grades.forEach(grade => {
                 const action3 = { type: actions.DELETE_GRADE, payload: grade._id };
                 dispatch(action3);
             });
         }
    } catch (error) {
        console.log(error);
    }
}

export const setAssignments = (assignments) => async (dispatch) => {
    try {
        let arrayOfGrades = [];
        assignments.forEach((assignment) => {
            if (assignment.grades && assignment.grades.length > 0) {
                const filteredGrades = assignment.grades.filter(grade => grade !== null);
                const gradesWithAssignmentInfo = filteredGrades.map(grade => ({
                    ...grade,
                    assignment: assignment,
                }));
                arrayOfGrades = [...arrayOfGrades, ...gradesWithAssignmentInfo];
            }
        });

        if (arrayOfGrades.length > 0) {
            dispatch(setGrades(arrayOfGrades));
        }

        const action = { type: actions.SET_ASSIGNMENTS, payload: assignments };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}




export const addAssignment = (assignment) => async (dispatch) => {
    try {

        const { data } = await client.mutate({
            mutation: ADD_ASSIGNMENT,
            variables: { input: assignment },
        });
        const savedAssignment = data.createAssignment;
        const action = { type: actions.ADD_ASSIGNMENT, payload: savedAssignment };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}




export const updateAssignment = (assignment) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: UPDATE_ASSIGNMENT,
            variables: { input: assignment },
        });
        const savedAssignment = data.updateAssignment;
        const action = { type: actions.UPDATE_ASSIGNMENT, payload: savedAssignment };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
